import { useFeatureFlagEnabled, usePostHog } from "@posthog/react";

type PostHogFeatureFlagState = {
  enabled: boolean;
  isLoading: boolean;
};

const isLocalhost = window.location.hostname === "localhost";

export const usePostHogFeatureFlag = (flagKey: string): PostHogFeatureFlagState => {
  const posthog = usePostHog();
  const enabled = useFeatureFlagEnabled(flagKey);
  const hasLoadedFlags = Boolean(posthog.featureFlags?.hasLoadedFlags);

  if (isLocalhost) {
    return { enabled: true, isLoading: false };
  }

  if (!posthog?.onFeatureFlags) {
    return { enabled: false, isLoading: false };
  }

  return {
    enabled: enabled === true,
    isLoading: !hasLoadedFlags && enabled === undefined,
  };
};
